<template>
	<span class="cp-info">
		<v-menu
			max-width="500"
			open-on-hover
			offset-y
			top
			nudge-top="5"
			:nudge-left="nudgeLeft"
			content-class="elevation-0"
		>
			<template #activator="{ on }">
				<v-icon class="icone-tooltip-informativo ml-1 mr-0" :size="size" :color="color" v-on="on">{{
					icon
				}}</v-icon>
			</template>

			<div v-if="mensagemPadraoTooltip" class="cp-info-content" v-html="mensagemPadraoTooltip"></div>
		</v-menu>
	</span>
</template>

<script>
export default {
	name: 'tooltip-informativo',
	props: {
		mensagemPadraoTooltip: {
			type: String,
			default: 'mensagem',
		},
		icon: {
			type: String,
			default: 'info_outlined',
		},
		color: {
			type: String,
			default: '',
		},
		nudgeLeft: {
			type: Number,
			default: 0,
		},
		size: {
			type: String,
			default: '15',
		},
	},
}
</script>

<style lang="stylus" scoped>
.icone-tooltip-informativo
	margin-left 4px
	margin-bottom 8px

.cp-info
	.v-menu__content
		background red

	&-content
		padding 10px
		font-size 12px
		opacity 1 !important
		background #333333 !important
		text-align justify !important
		line-height 1.4
		color white
</style>
